import React from 'react'
import { connect } from 'react-redux'
import { selectCurrentCustomer } from 'selectors/tickets'
import {
  selectSidebarCardData,
  selectIsSidebarCardFailed,
  selectIsSidebarCardLoading,
} from 'selectors/sidebar_cards'
import {
  selectEmailMarketingSubscriptions,
  selectEmailMarketingAvailableLists,
} from 'selectors/email_marketing'
import {
  doFetchEmailMarketingIntegrationState,
  doSubscribeToEmailList,
  doUnsubscribeFromEmailList,
} from 'actions/email_marketing'
import { runOnNextTick } from 'util/functions'
import { emptyObj } from 'util/objects'

const EmailMarketingCard = Content => {
  const selectFactory = (initialState, initialOwnProps) => {
    const { id: cardId } = initialOwnProps

    return state => ({
      customer: (selectCurrentCustomer(state) || emptyObj).id,
      data: selectSidebarCardData(state)(`legacy_${cardId}`),
      subscriptions: selectEmailMarketingSubscriptions(state)(cardId),
      availableLists: selectEmailMarketingAvailableLists(state)(cardId),
      isFailed: selectIsSidebarCardFailed(state)(`legacy_${cardId}`),
      isLoading: selectIsSidebarCardLoading(state)(`legacy_${cardId}`),
    })
  }

  const performFactory = (initialState, initialOwnProps) => {
    const { customerId, id: cardId } = initialOwnProps

    return dispatch => ({
      load: () =>
        dispatch(doFetchEmailMarketingIntegrationState(cardId, customerId)),
      onSubscribe: listId => {
        dispatch(doSubscribeToEmailList(cardId, customerId, listId))
      },
      onUnsubscribe: listId => {
        dispatch(doUnsubscribeFromEmailList(cardId, customerId, listId))
      },
    })
  }

  class CustomerChangeHandler extends React.Component {
    componentDidMount() {
      this.runLoad()
    }

    componentDidUpdate(prevProps) {
      if (!this.props.customer) return
      if (prevProps.customer !== this.props.customer) this.runLoad()
    }

    runLoad() {
      runOnNextTick(this.props.load)
    }

    render() {
      return <Content {...this.props} />
    }
  }

  return connect(selectFactory, performFactory)(CustomerChangeHandler)
}

export default EmailMarketingCard
